var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#0061FF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2l6 3.9 6-3.9-6-3.9L6 2zm12 7.8l6-4-6-3.9-6 3.9 6 4zm-12 0l6-3.9-6-3.9-6 3.9 6 3.9zm0 7.8l6-3.9-6-3.9-6 3.9 6 3.9zm12 0l6-3.9-6-3.9-6 3.9 6 3.9zm-6 1.3l-6-3.9-6 3.9 6 3.9 6-3.9zm0 0l6 3.9 6-3.9-6-3.9-6 3.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.761718dcf2d8289d7105afa47e887cab.svg";
export { ForwardRef as ReactComponent };